// import {createSlice, isAnyOf} from '@reduxjs/toolkit'
// import {PlatformDataType} from 'src/interfaces/Platform.interface'
// import {fetchConnectedPlatformAsync} from '../actions/platformActions'

// type fetchConnectedPlatformPayoad = {
//   fetchedConnectedPlatformData: PlatformDataType[] | []
//   fetchedConnectedPlatformLoading: boolean
// }

// const initialState: fetchConnectedPlatformPayoad = {
//   fetchedConnectedPlatformData: [],
//   fetchedConnectedPlatformLoading: false,
// }

// const fetchConnectedPlatformSlice = createSlice({
//   name: 'fetchedConnectedPlatformSlice',
//   initialState,
//   extraReducers: (builder) => {
//     builder.addMatcher(isAnyOf(fetchConnectedPlatformAsync.pending), (state, action) => {
//       state.fetchedConnectedPlatformLoading = true
//     })
//     builder.addMatcher(isAnyOf(fetchConnectedPlatformAsync.fulfilled), (state, action) => {
//       state.fetchedConnectedPlatformLoading = false
//       state.fetchedConnectedPlatformData = action?.payload?.data
//     })
//     builder.addMatcher(isAnyOf(fetchConnectedPlatformAsync.rejected), (state) => {
//       state.fetchedConnectedPlatformLoading = true
//     })
//   },
//   reducers: {
//     setFetchedConnectedPlatformData: (state, action: {payload: fetchConnectedPlatformPayoad; type: string}) => {
//       state.fetchedConnectedPlatformLoading = action.payload?.fetchedConnectedPlatformLoading
//       state.fetchedConnectedPlatformData = action?.payload.fetchedConnectedPlatformData
//     },
//   },
// });

// export const {setFetchedConnectedPlatformData} = fetchConnectedPlatformSlice.actions
// export default fetchConnectedPlatformSlice.reducer;
import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { PlatformDataType } from 'src/interfaces/Platform.interface';
import { fetchConnectedPlatformAsync, deletePlatformDataAsync, getAllPlatformTypesAsync, fetchSourcePlatformAsync } from '../actions/platformActions';

type FetchConnectedPlatformPayload = {
  fetchedConnectedPlatformData: PlatformDataType[] | [];
  fetchedConnectedPlatformLoading: boolean;
  mainStoreData: null | PlatformDataType;
  accountingStoreData: null | PlatformDataType;
  shippingStoreData: null | PlatformDataType;
  erpStoreData: null | PlatformDataType;
  omsStoreData: null | PlatformDataType;
  ticketStoreData: null | PlatformDataType;
  connectedPlatformTypesLoading: boolean;
  connectedPlatformTypes: Record<string, any> | null;
  fetchedSourcePlatformData: null | { source_platform: PlatformDataType };
};

const initialState: FetchConnectedPlatformPayload = {
  fetchedConnectedPlatformData: [],
  fetchedConnectedPlatformLoading: true,
  mainStoreData:null,
  accountingStoreData: null,
  shippingStoreData: null,
  erpStoreData: null,
  omsStoreData: null,
  ticketStoreData: null,
  connectedPlatformTypesLoading: true,
  connectedPlatformTypes: null,
  fetchedSourcePlatformData: null
};

const isTicketLikeStore = (item: PlatformDataType | null | undefined): boolean => {
  if (!item) return false
  if (item.isTicketStore) return true

  const type = `${item.platform_info?.type ?? item.type ?? ''}`.toUpperCase()
  const code = `${item.code ?? ''}`.toUpperCase()
  const name = `${item.name ?? item.platform_info?.name ?? ''}`.toUpperCase()

  return type === 'TICKET' || code.includes('TICKET') || name.includes('TICKET')
}

const fetchConnectedPlatformSlice = createSlice({
  name: 'fetchedConnectedPlatformSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchConnectedPlatformAsync.pending, (state, action) => {
        state.fetchedConnectedPlatformLoading = true;
      })
      .addCase(fetchConnectedPlatformAsync.fulfilled, (state, action) => {
        
        if(action.payload?.data){
          state.fetchedConnectedPlatformData = action.payload?.data;

          if(action.payload?.data?.length){
            const mainSD =  action.payload?.data?.find((item)=>{
                if(item?.isMainStore){
                  return item
                }
            })
            state.mainStoreData = mainSD

             const accountingSD =  action.payload?.data?.find((item)=>{
                if(item?.isAccountingStore){
                  return item
                }
            })
            state.accountingStoreData = accountingSD

            const shippingSD =  action.payload?.data?.find((item)=>{
                if(item?.isShippingStore){
                  return item
                }
            })
            state.shippingStoreData = shippingSD

            const erpSD = action.payload?.data?.find((item) => {
              if (item?.isErpStore) {
                return item
              }
            })
            state.erpStoreData = erpSD ?? null

            const omsSD = action.payload?.data?.find((item) => {
              if (item?.isOmsStore) {
                return item
              }
            })
            state.omsStoreData = omsSD ?? null

            const ticketSD = action.payload?.data?.find((item) => isTicketLikeStore(item))
            state.ticketStoreData = ticketSD ?? null
          }

        }
        state.fetchedConnectedPlatformLoading = false;
      
      })
      .addCase(fetchConnectedPlatformAsync.rejected, (state) => {
        state.fetchedConnectedPlatformLoading = false;
      })
      .addCase(deletePlatformDataAsync.pending, (state, action) => {
        // Since we're deleting, we don't necessarily need to set fetching to true here
      })
      .addCase(deletePlatformDataAsync.fulfilled, (state, action) => {
        // Check if action.payload exists and has the deletedPlatformId property
        // if (action.payload && action.payload.deletedPlatformId) {
        //   state.fetchedConnectedPlatformData = state.fetchedConnectedPlatformData.filter(
        //     (platform) => platform.id !== action.payload.deletedPlatformId
        //   );
        if (action.payload && action.meta.arg.id) {
          const updatedPlatforms = state.fetchedConnectedPlatformData.filter(
            (platform) => platform.id !== action.meta.arg.id
          );
          state.fetchedConnectedPlatformData = updatedPlatforms;
          
          // Recalculate mainStoreData
          const newMainStore = updatedPlatforms.find((item) => item?.isMainStore);
          state.mainStoreData = newMainStore ?? null;
          
          // Recalculate accountingStoreData
          const newAccountingStore = updatedPlatforms.find((item) => item?.isAccountingStore);
          state.accountingStoreData = newAccountingStore ?? null;

            // Recalculate accountingStoreData
          const newShippingStore = updatedPlatforms.find((item) => item?.isShippingStore);
          state.shippingStoreData = newShippingStore ?? null;

          const newErpStore = updatedPlatforms.find((item) => item?.isErpStore);
          state.erpStoreData = newErpStore ?? null;

          const newOmsStore = updatedPlatforms.find((item) => item?.isOmsStore);
          state.omsStoreData = newOmsStore ?? null;

          const newTicketStore = updatedPlatforms.find((item) => isTicketLikeStore(item));
          state.ticketStoreData = newTicketStore ?? null;
        }
      })
      .addCase(deletePlatformDataAsync.rejected, (state) => {
        // Handle any errors or set loading to false if necessary
      })
      .addCase(getAllPlatformTypesAsync.pending, (state, action) => {
               state.connectedPlatformTypesLoading = true;
      }).addCase(getAllPlatformTypesAsync.fulfilled, (state, action) => {
               state.connectedPlatformTypes = action.payload
               state.connectedPlatformTypesLoading = false;
      }).addCase(getAllPlatformTypesAsync.rejected, (state, action) => {
              state.connectedPlatformTypesLoading = false;
      })
      .addCase(fetchSourcePlatformAsync.rejected, (state) => {
      })
      .addCase(fetchSourcePlatformAsync.pending, (state, action) => {
      })
      .addCase(fetchSourcePlatformAsync.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.fetchedSourcePlatformData = action.payload?.data;
        }
      });
      
  },
  reducers: {
    setFetchedConnectedPlatformData: (
      state,
      action: { payload: FetchConnectedPlatformPayload; type: string }
    ) => {
      state.fetchedConnectedPlatformLoading = action.payload.fetchedConnectedPlatformLoading;
      state.fetchedConnectedPlatformData = action.payload.fetchedConnectedPlatformData;

      state.connectedPlatformTypes = action.payload.connectedPlatformTypes
      state.connectedPlatformTypesLoading = action.payload.connectedPlatformTypesLoading
      state.erpStoreData = action.payload.erpStoreData
      state.omsStoreData = action.payload.omsStoreData
      state.ticketStoreData = action.payload.ticketStoreData

    },
  },
});

export const { setFetchedConnectedPlatformData } = fetchConnectedPlatformSlice.actions;
export default fetchConnectedPlatformSlice.reducer;
